import React, { useEffect } from "react";
import "./PsychicAnimation.css";

export default function PsychicAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl   = playerRef.current;
    const opponentEl = opponentRef.current;
    const container  = playerEl.closest(".battle-container");
    const bg         = container?.querySelector(".battle-bg");
    if (!playerEl || !opponentEl || !container) return;

    // 1) “Thinking” shake on the user Pokémon
    playerEl.classList.add("psychic-concentrate");
    setTimeout(() => playerEl.classList.remove("psychic-concentrate"), 600);

    // 2) Compute positions
    const pRect = playerEl.getBoundingClientRect();
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();
    const startX = (pRect.left + pRect.width  / 2) - cRect.left;
    const startY = (pRect.top  + pRect.height / 2) - cRect.top;
    const endX   = (oRect.left + oRect.width  / 2) - cRect.left;
    const endY   = (oRect.top  + oRect.height / 2) - cRect.top;
    const dx = endX - startX, dy = endY - startY;

    // 3) Spawn psychic orbs
    const count = 6;
    const orbs  = [];
    for (let i = 0; i < count; i++) {
      const orb = document.createElement("div");
      orb.className = "psychic-orb";
      orb.style.left = `${startX}px`;
      orb.style.top  = `${startY}px`;
      orb.style.setProperty("--dx", `${dx + (Math.random()-0.5)*30}px`);
      orb.style.setProperty("--dy", `${dy + (Math.random()-0.5)*30}px`);
      orb.style.animationDelay = `${i * 0.08}s`;
      container.appendChild(orb);
      orbs.push(orb);
    }

    // 4) After the last orb hits, do impact + cleanup
    const last = orbs[orbs.length - 1];
    const handleImpact = () => {
      orbs.forEach(o => o.remove());

      // shake & tint the foe
      opponentEl.classList.add("psychic-hit");
      setTimeout(() => opponentEl.classList.remove("psychic-hit"), 400);

      // flash the background
      if (bg) {
        bg.classList.add("psychic-bg");
        setTimeout(() => bg.classList.remove("psychic-bg"), 500);
      }

      // ripple effect
      const ripple = document.createElement("div");
      ripple.className = "psychic-ripple";
      ripple.style.left = `${endX}px`;
      ripple.style.top  = `${endY}px`;
      container.appendChild(ripple);
      setTimeout(() => {
        ripple.remove();
        onComplete();
      }, 600);

      last.removeEventListener("animationend", handleImpact);
    };
    last.addEventListener("animationend", handleImpact);

    // cleanup if unmounted early
    return () => {
      orbs.forEach(o => o.remove());
      last.removeEventListener("animationend", handleImpact);
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

PsychicAnimation.moveType = "psychic";
